export default {
    "The online prints tool is loading. Please wait": "The online prints tool is loading. Please wait",
    "Add photos": "Add photos",
    "Options": "Options",
    "Extras": "Extras",
    "Upload your photos": "Upload your photos",
    "Get started! Upload some photos": "Get started! Upload some photos",
    "We’re analyzing your photos for the next step. Analyzing photos %s of %s": "We’re analyzing your photos for the next step. Analyzing photos %s of %s",
    "%s You’ve already uploaded this photo.": "%s You’ve already uploaded this photo.",
    "We couldn’t read the image ‘%s’ so it will not be included in your image collection. This might happen if the file is not an image file (for example a jpeg or png), or because the image is broken. Please check the file and try to re-upload it": "We couldn’t read the image ‘%s’ so it will not be included in your image collection. This might happen if the file is not an image file (for example a jpeg or png), or because the image is broken. Please check the file and try to re-upload it.",
    "We couldn’t upload the image ‘%s’ because you tried to upload a file type the editor doesn’t support. Supported types are ‘%s’.": "We couldn’t upload the image ‘%s’ because you tried to upload a file type the editor doesn’t support. Supported types are ‘%s’.",
    "We couldn’t upload the image ‘%s’ because the image is too large. The maximum file size is %s.": "We couldn’t upload the image ‘%s’ because the image is too large. The maximum file size is %s.",
    "We couldn’t upload the image ‘%s’ because the image is too large. The maximum allowed dimensions are %s x %s pixels.": "We couldn’t upload the image ‘%s’ because the image is too large. The maximum allowed dimensions are %s x %s pixels.",
    "Could not upload ‘%s’ because of error: %s. See console for more info.": "Could not upload ‘%s’ because of error: %s. See console for more info.",
    "Upload more photos": "Upload more photos",
    "Your photos are uploading: %s of %s complete": "Your photos are uploading: %s of %s complete",
    "Photos added: ‘%s’ to your collection": "Photos added: ‘%s’ to your collection",
    "%s of %s uploaded": "%s of %s uploaded",
    "Cannot show photo. Please try deleting and uploading again. If it still doesn’t show, please contact us.": "Cannot show photo. Please try deleting and uploading again. If it still doesn’t show, please contact us.",
    "Your photo collection": "Your photo collection",
    "Tap here to change photo format, add a filter or change quantity, for all photos in this order": "Tap here to change photo format, add a filter or change quantity, for all photos in this order",
    "Swipe to reveal more options": "Swipe to reveal more options",
    "We will make you aware if images are low resolution and notify you when cropping will occur.": "We will make you aware if images are low resolution and notify you when cropping will occur.",
    "Edit your photos": "Edit your photos",
    "You’re ordering %s photos": "You’re ordering %s photos",
    "Low resolution images": "Low resolution images",
    "You’ve uploaded one or more images at low resolution. These images might see loss in quality in print.": "You’ve uploaded one or more images at low resolution. These images might see loss in quality in print.",
    "For better results, choose a smaller print size. Low resolution images have been marked with the icon displayed above.": "For better results, choose a smaller print size. Low resolution images have been marked with the icon displayed above.",
    "One or more photos have been cropped to fit the selected print size.": "One or more photos have been cropped to fit the selected print size.",
    "Cropped photos have been marked with the icon displayed above. We recommend that you check your cropped photos before ordering.": "Cropped photos have been marked with the icon displayed above. We recommend that you check your cropped photos before ordering.",
    "Cannot show photo. Please try deleting and uploading it again. If it still doesn’t show, please contact us.": "Cannot show photo. Please try deleting and uploading it again. If it still doesn’t show, please contact us.",
    "Duplicate photo": "Duplicate",
    "Cropped photos": "Cropped photos",
    "Info": "Info",
    "More info": "More info",
    "Total": "Total",
    "Finish your order": "Finish your order",
    "Save and finish later": "Save and finish later",
    "Got it!": "Got it!",
    "Low resolution image": "Low resolution image",
    "Photo cropped": "Photo cropped",
    "Standard sizes": "Standard sizes",
    "Enlargements": "Photo enlargements",
    "Edit": "Edit",
    "Save": "Save",
    "Reset": "Reset",
    "Original": "Original",
    "Sephia": "Sephia",
    "B/W": "B/W",
    "Black and white": "Black and white",
    "Edit all": "Edit all",
    "Done": "Done",
    "Select filter": "Select filter",
    "Close": "Close",
    "Add filter": "Add filter",
    "List of available filters...": "List of available filters...",
    "Select format": "Select format",
    "Choose size": "Choose size",
    "Size:": "Size:",
    "Editing multiple photos will be available when all the photos are analyzed": "Editing multiple photos will be available when all the photos are analyzed",
    "Amount": "Amount",
    "Prints": "Prints",
    "Cannot show photo. Please try deleting and uploading it again and, if it still doesn’t show, please contact us for assistance.": "Cannot show photo. Please try deleting and uploading it again and, if it still doesn’t show, please contact us for assistance.",
    "Do more with your photos": "Do more with your photos",
    "Order your prints": "Order your prints",
    "Enlarge": "Enlarge",
    "%s photos": "%s photos",
    "Adding cart items. Two more steps...": "Adding cart items. Two more steps...",
    "We’re processing your order. One more step…": "We’re processing your order. One more step…",
    "Redirecting to cart. Just a moment...": "Redirecting to cart. Just a moment...",
    "Paper": "Paper",
    "Other": "Other",
    "Are you sure you want to delete this product from your shopping basket?": "Are you sure you want to delete this product from your shopping basket?",
    "Something went wrong when adding items to cart. See details below.": "Something went wrong when adding items to cart. See details below.",
    "Image enhancement will automatically optimise your images, bringing out the colour in every photo. We recommend disabling this option if you’ve already enhanced your photos with other software or apps, such as Instagram.": "Image enhancement will automatically optimise your images, bringing out the colour in every photo. We recommend disabling this option if you’ve already enhanced your photos with other software or apps, such as Instagram.",
    "You're ordering 1 print.": "You're ordering 1 print.",
    "Your device has lost internet connection": "",
    "Delete?": "",
    "Yes": "",
    "No": "",
    "The maximum allowed number of photos is %s but you can add multiple orders to one cart and buy all your photos at once. To order more, add this order to your cart then return to the editor.": "The maximum allowed number of photos is %s but you can add multiple orders to one cart and buy all your photos at once. To order more, add this order to your cart then return to the editor.",
    "For you to order, we need to finish uploading your photos": "",
    "%s premium prints": "",
    "Retro": "",
    "We’re sorry: we couldn’t registrer file %s, so we’ve removed it from your order. This might be a temporary error and you could try uploading it again": "",
    "Customer service": "",
    "Privacy": "",
    "Disclaimer": "",
    "Use photos from minnebanken": "Use photos from minnebanken",
    "Please log in with": "",
    "Memory bank": "",
    "%s photos selected": "",
    "Timeline": "",
    "Events": "",
    "Collections": "",
    "Import photos": "",
    "Choose collection": "",
    "Choose event": "",
    "Unable to get photos": "",
    "No photos": "",
    "More photos...": "",
    "Unable to get timeline data": "",
    "Unable to get events data": "",
    "Unable to get collections data": "",
    "No timelines": "",
    "No events": "",
    "No collections": "",
    "January": "",
    "February": "",
    "March": "",
    "April": "",
    "May": "",
    "June": "",
    "July": "",
    "August": "",
    "September": "",
    "October": "",
    "November": "",
    "December": "",
    "All months": "",
    "All days": "",
    "Click here to add polaroid text": "You can add text here",
    "Unable to resize photo. This sometimes happens when the browser is overloaded with lots of large photos. You can try a different browser, order fewer photos at a time or first upload to Photo Organiser.": "Unable to resize photo. This sometimes happens when the browser is overloaded with lots of large photos. You can try a different browser, order fewer photos at a time or first upload to Photo Organiser.",
    "Unable to resize photo. This sometimes happens when the browser is overloaded with lots of large photos. You can try a different browser or order fewer photos at a time.": "Unable to resize photo. This sometimes happens when the browser is overloaded with lots of large photos. You can try a different browser or order fewer photos at a time.",
    "Could not load photos from Photo Organiser because there are no photos in the basket.": "Could not load photos from Photo Organiser because there are no photos in the basket.",
    "Please know that if you leave the page now, your changes will be lost": "",
    "Quantity:": "",
    "Loading photos from minnebanken...": "Loading photos from minnebanken...",
    "Select all": "",
    "Select nothing": "",
    "Check your photos": "Check your photos",
    "Loading...": "",
    "Loading, please wait": "Hang tight! We're nearly with you.",
    "%s images have a low-resolution warning. Please double-check the photos marked with a warning sign. If you don't, we can't guarantee top quality on your prints.": "%s images have a low-resolution warning. Please double-check the photos marked with a warning sign. If you don't, we can't guarantee top quality on your prints.",
    "%s photos have been cropped and not validated. Please double-check the photos marked with a warning sign. If you don't, we can't guarantee top quality on your prints.": "%s photos have been cropped and not validated. Please double-check the photos marked with a warning sign. If you don't, we can't guarantee top quality on your prints.",
    "Some photos need attention": "Some photos need attention",
    "Continue": "",
    "Check photos": "Check photos",
    "Check your cropped photos": "Check your cropped photos",
    "Check your low resolution images": "",
    "Unable to load images from temporary selection API in Photo Organise": "",
    "Unfortunately your browser does not support all options for creating this product. Please install Safari, Chrome, Firefox or a newer version of Internet Explorer (11 or Edge) and start again.": ""
};
